<template>
  <b-modal
    v-model="showModal"
    :title="`DETALLE DEL ACUMULADO: ${conductor.personal_name || ''}`"
    modal-class="modal-primary"
    size="xl"
    hide-footer
    no-close-on-backdrop
    scrollable
    @hidden="$emit('hidden')"
  >
    <b-row class="mb-1">
      <b-col md="6">
        <b-alert show variant="primary" class="p-1 mb-0">
          <feather-icon icon="InfoIcon" class="mr-25" />
          Cada mes suma la meta de su régimen y descuenta los días gozados y
          vendidos. Los meses ya cerrados no se recalculan.
        </b-alert>
      </b-col>
      <b-col md="6" class="text-right">
        <h4 class="mt-1">
          Saldo acumulado:
          <b-badge :variant="acumulado < 0 ? 'danger' : 'success'">
            {{ acumulado }} días
          </b-badge>
        </h4>
      </b-col>
    </b-row>

    <b-table
      small
      responsive
      sticky-header="55vh"
      :items="detalle"
      :fields="fields"
      :busy="isBusy"
      show-empty
      empty-text="Sin movimientos en el rango"
    >
      <template #table-busy>
        <div class="text-center my-2">
          <b-spinner class="align-middle" />
        </div>
      </template>

      <template #cell(periodo)="data">
        <span class="font-weight-bolder">{{ data.value }}</span>
        <b-badge
          v-if="estaCerrado(data.value)"
          variant="light-secondary"
          class="ml-50"
        >
          <feather-icon icon="LockIcon" size="11" /> cerrado
        </b-badge>
      </template>

      <template #cell(regimen)="data">
        <b-badge v-if="data.value" variant="light-primary">
          {{ data.value }}
        </b-badge>
        <span v-else class="text-danger">sin régimen</span>
      </template>

      <template #cell(meta)="data">
        <b-badge variant="light-info">+{{ data.value }}</b-badge>
      </template>

      <template #cell(tomados)="data">
        <b-badge variant="light-success">-{{ data.value }}</b-badge>
      </template>

      <template #cell(vendidos)="data">
        <b-badge variant="light-warning">-{{ data.value }}</b-badge>
      </template>

      <template #cell(ajustes)="data">
        <b-badge :variant="data.value ? 'light-dark' : 'light-secondary'">
          {{ data.value > 0 ? "+" : "" }}{{ data.value }}
        </b-badge>
      </template>

      <template #cell(saldo_mes)="data">
        <span :class="data.value < 0 ? 'text-danger' : 'text-success'">
          {{ data.value > 0 ? "+" : "" }}{{ data.value }}
        </span>
      </template>

      <template #cell(saldo_acumulado)="data">
        <b-badge :variant="data.value < 0 ? 'danger' : 'primary'">
          {{ data.value }}
        </b-badge>
      </template>
    </b-table>
  </b-modal>
</template>

<script>
import DiasLibresReportService from "@/views/monitoring/views/dias-libres/services/dias-libres-report.service.js";

export default {
  props: {
    conductor: {
      type: Object,
      required: true,
    },
    periodo: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showModal: true,
      isBusy: false,
      detalle: [],
      cierres: [],
      acumulado: 0,
      fields: [
        { key: "periodo", label: "Periodo" },
        { key: "regimen", label: "Régimen" },
        { key: "meta", label: "Meta", class: "text-center" },
        { key: "tomados", label: "Gozados", class: "text-center" },
        { key: "vendidos", label: "Vendidos", class: "text-center" },
        { key: "ajustes", label: "Ajustes", class: "text-center" },
        { key: "saldo_mes", label: "Mov. del mes", class: "text-center" },
        { key: "saldo_acumulado", label: "Acumulado", class: "text-center" },
      ],
    };
  },
  created() {
    this.getDetalle();
  },
  methods: {
    async getDetalle() {
      try {
        this.isBusy = true;
        const { data } = await DiasLibresReportService.getDetalle({
          personal_id: this.conductor.personal_id,
          periodo: this.periodo,
        });
        this.cierres = data.cierres;
        this.acumulado = data.acumulado;
        // El calculo en vivo arranca despues del ultimo cierre: para ver la
        // historia completa se anteponen los meses ya cerrados
        this.detalle = this.combinarHistoria(data.cierres, data.detalle);
      } catch (error) {
        console.log(error);
      } finally {
        this.isBusy = false;
      }
    },

    combinarHistoria(cierres, detalle) {
      const periodosEnVivo = detalle.map((item) => item.periodo);

      const cerrados = cierres
        .filter((item) => !periodosEnVivo.includes(item.periodo))
        .map((item) => ({
          periodo: item.periodo,
          regimen: item.regimen,
          meta: Number(item.meta),
          tomados: Number(item.tomados),
          vendidos: Number(item.vendidos),
          ajustes: Number(item.ajustes),
          saldo_mes: Number(item.saldo_mes),
          saldo_acumulado: Number(item.saldo_acumulado),
        }));

      return [...cerrados, ...detalle].sort((a, b) =>
        a.periodo.localeCompare(b.periodo)
      );
    },

    estaCerrado(periodo) {
      return this.cierres.some((item) => item.periodo === periodo);
    },
  },
};
</script>
